import { useMutation, useQuery } from '@tanstack/react-query';
import { httpService } from '../../../Helpers/Fetcher/axios';
import { commApi } from './commconstant';
import {
  commonAxiosError,
  commonAxiosSuccess,
} from '../../../Utils/TanstackQuery/queryClient';

export type ICountry = {
  id: number;
  name: string;
  continent_id: number;
};

export const useGetAllCountryList = ({
  continent_id,
  name,
}: {
  continent_id?: number;
  name: string;
}) => {
  return useQuery({
    queryKey: ['/api/common/country', continent_id, name],
    queryFn: () =>
      httpService.get<ICountry[]>({
        url: `/api/common/country`,
        params: { continent_id, name },
      }),
    // enabled: !!continent_id,
  });
};

export const useCheckPreviousRegistration = () => {
  return useMutation({
    mutationFn: (data: {
      phone?: string;
      email: string;
      type:
        | 'previous_exhibitor'
        | 'previous_b2b'
        | 'previous_visitor'
        | 'register_fair'
        | 'register_b2b'
        | 'register_visitor';
    }) =>
      httpService.post({
        url: `${commApi.CHECK_PREVIOUS_REGISTRATION}`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Done!`);
      // queryClient.invalidateQueries({
      //   queryKey: [commApi.CREATE_PREVIOUS_REGISTRATION],
      // });
    },

    onError: commonAxiosError(),
  });
};
export const useCreatePreviousRegistration = () => {
  return useMutation({
    mutationFn: (data: {
      email: string;
      type: 'exhibitor' | 'b2b' | 'visitor';
      password: string;
    }) =>
      httpService.post({
        url: `${commApi.CREATE_PREVIOUS_REGISTRATION}`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Status Updated!`);
      // queryClient.invalidateQueries({
      //   queryKey: [commApi.CREATE_PREVIOUS_REGISTRATION],
      // });
    },

    onError: commonAxiosError(),
  });
};
export const usePreviousMatchOTP = () => {
  return useMutation({
    mutationFn: (data: {
      email: string;
      type:
        | 'previous_b2b'
        | 'register_fair'
        | 'register_b2b'
        | 'register_visitor';
      otp: string;
    }) =>
      httpService.post({
        url: `${commApi.MATCH_OTP}`,
        data,
      }),
    onSuccess: () => {
      commonAxiosSuccess(`Successfully Done!`);
      // queryClient.invalidateQueries({
      //   queryKey: [commApi.CREATE_PREVIOUS_REGISTRATION],
      // });
    },

    onError: commonAxiosError(),
  });
};
